import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import { ITravelFlightAirline } from '@shared/shared/interfaces/travel-flight.interfaces';
import * as fromFlightAirlinesReducer from './flight-airlines.reducers';

export interface TravelInformationState {
  flightAirlines: Array<ITravelFlightAirline>;
}

export const reducers: ActionReducerMap<TravelInformationState> = {
  flightAirlines: fromFlightAirlinesReducer.reducer,
};

export const getTravelInformationState = createFeatureSelector<TravelInformationState>('travel-information');
